<template>
  <h2
    class="
      primary-color
      font-size-md font-weight-semibold
      text-center
      e2e-topstrip-storeaddress
    "
    v-if="storeInfo"
  >
    {{ formatAddress(storeInfo.singleline) }}
    <span v-if="lines === 1">&#x000B7;</span>
    <br v-if="lines === 2" />
    {{ formatPhoneNumber(storeInfo.phone) }}
  </h2>
</template>

<script>
import { mapState } from "vuex";
import { formatAddress, formatPhoneNumber } from "@/util.js";

export default {
  name: "StoreAddress",
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatAddress,
    formatPhoneNumber,
  },
  props: {
    lines: Number,
  },
};
</script>

<style scoped>
</style>
